<script lang="ts">
  import { mdiHandBackRightOutline, mdiTruckDeliveryOutline } from "@mdi/js"
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import InboxActionToggleCell from "../../../../../../_shared/_modules/inbox-action-toggle-cell"
  import type { LetterDeliveryDecisionDraft, LetterDeliveryDecisionRow } from "../../contract"

  type DeliveryModeOption = {
    value: string
    label: string
    disabled?: boolean
    tooltip?: string | null
    tooltipContent?: string | null
    dataTestid?: string
  }

  let props: InboxWorkflowCellProps<LetterDeliveryDecisionRow, LetterDeliveryDecisionDraft> =
    $props()
  const printRow = $derived(props.row)
  const isGenericNotice = $derived(
    printRow.selection?.print_mode === "GENERIC_KLEBEZETTEL" ||
      printRow.default_mode === "GENERIC_KLEBEZETTEL" ||
      printRow.binding?.defaultMode === "GENERIC_KLEBEZETTEL",
  )
  const fallbackOptions: DeliveryModeOption[] = [
    { value: "manual", label: "Händisch" },
    { value: "automatic", label: "Automatisch" },
  ]
  const toToggleOption = (option: {
    value: string
    label?: string
    name?: string
    disabled?: boolean
    tooltip?: string | null
    tooltipContent?: string | null
    dataTestid?: string
  }): DeliveryModeOption => ({
    value: option.value,
    label: option.label ?? option.name ?? option.value,
    disabled: option.disabled,
    tooltip: option.tooltip,
    tooltipContent: option.tooltipContent,
    dataTestid: option.dataTestid,
  })
  const options = $derived(
    isGenericNotice
      ? [{ value: "manual", label: "Händisch" }]
      : props.binding.options.length
        ? props.binding.options.map(toToggleOption)
        : fallbackOptions,
  )
  const rawValue = $derived(String(props.binding.value ?? ""))
  const displayedOptions = $derived(
    rawValue === "automatic" && !options.some((option) => option.value === rawValue)
      ? [...options, { value: "automatic", label: "Automatisch", disabled: true }]
      : options,
  )
</script>

{#if props.row.statusLabel === "Bewusst ignoriert"}
  <span style="color: var(--text-invers-100)">Bewusst ignoriert</span>
{:else}
  <InboxActionToggleCell
    value={rawValue}
    options={displayedOptions.map((option) => ({
      ...option,
      icon: option.value === "automatic" ? mdiTruckDeliveryOutline : mdiHandBackRightOutline,
    }))}
    disabled={props.binding.disabled}
    ariaLabel="Zustellart"
    allowEmptySelection={true}
    onChange={(next) => {
      if (displayedOptions.some((option) => option.value === next && !option.disabled)) {
        props.binding.setValue(next)
      }
    }}
  />
{/if}
